import { useSelector } from "react-redux";
import { IMainReduxState, IWebsiteConfig } from "core/interfaces.config";

const useWebsiteConfiguration = (): IWebsiteConfig =>
  useSelector((reducers: IMainReduxState) => reducers.websiteConfiguration);

export default useWebsiteConfiguration;
